module.exports = __webpack_public_path__ + "img/badge-gold.8ab7a781.png";